import { addDays, startOfDay } from 'date-fns';
import { notifyWarehouseUpdated } from '../../../common/signalr/signalrActions';
import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { fetchStocksForDay, fetchWarehouses, updateWarehouse } from './stockSlices';

const warehouses$ = createEpicFromAsyncActionEmptyRequest(
    fetchWarehouses,
    ({ warehouseClient }) => warehouseClient.getAll(),
    // Fetch warehouse balance for the primary warehouse (the first item in warehouse array), for tomorrow
    // when client has received warehouses
    warehouses => {
        if (warehouses.length === 0) {
            return null;
        }

        return fetchStocksForDay.request({
            date: addDays(startOfDay(new Date()), 1).toISOString(),
            warehouseId: warehouses.find(w => w.isPrimaryWarehouse)?.warehouseId ?? warehouses[0].warehouseId
        });
    }
);

const stocks$ = createEpicFromAsyncAction(fetchStocksForDay, (payload, { stockClient }) =>
    stockClient.getStocksForDay(payload.date, payload.warehouseId)
);

const updateWarehouse$ = createEpicFromAsyncAction(
    updateWarehouse,
    (payload, { warehouseClient }) =>
        warehouseClient.updateWarehouse(payload.warehouseId, payload).then(() => payload),
    req => notifyWarehouseUpdated(req.warehouseId)
);

export default [warehouses$, stocks$, updateWarehouse$];
